import { Component, OnInit, Inject } from '@angular/core';
import { WindowsService } from 'src/app/shared/services/window-service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
export class PhoneNumber {
  number: string;
  get e164() {
    const num = this.number
    return `+${972 + num}`
  }
};
@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss']
})

export class PhoneComponent implements OnInit {

  constructor(private windowService: WindowsService, private router: Router, private authService: AuthService) { }
  windowRef: any;
  phoneNumber = new PhoneNumber();
  verficationCode: number;
  user: any;
  error: string;
  selectedPhone: number;
  phone;
  recapchaApproved: boolean = false;
  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.goToSubmitForm();
    }
    this.windowRef = this.windowService.windowRef;
    this.windowRef.recaptchVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
      'callback': (response) => {
        this.recapchaApproved = true;
      }
    });

    this.windowRef.recaptchVerifier.render();
  }


  submit() {
    this.error = null;
    // if (!this.selectedPhone || this.selectedPhone<999999999 ) {
    //   this.error = " אנא הזן מספר טלפון תקין"
    //   return;
    // }
    this.sendLoginCode()
    // this.dialogRef.close({ "branch": this.selectedBranch, "now": this.now, "hour": this.selectedHour });
  }

  sendLoginCode() {
    if (!this.recapchaApproved) {
      this.error = "The CAPTCHA verification failed."
    }
    if (!this.validatePhone(this.phoneNumber.number)) {
      this.error = "מספר טלפון לא תקין"
    }
    const appVerifier = this.windowRef.recaptchVerifier;
    const num = this.phoneNumber.e164;
    firebase.auth().signInWithPhoneNumber(num, appVerifier).then(result => {
      this.windowRef.confirmationResult = result;
    }).catch(err => console.log(err))
  }

  verifyLoginCode() {
    this.windowRef.confirmationResult.confirm(this.verficationCode.toString()).then(result => {
      this.user = result.user
      this.goToSubmitForm();
    }).catch(err => {
      this.error = err;
    }
    )
  }

  validatePhone(phone): boolean {
    const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return regex.test(phone)
  }

  goToSubmitForm() {
    this.router.navigate(["checkout"]);
  }

}
